<!--
 * @Author: FengXiao
 * @Date: 2020-07-02 15:09:52
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-02 21:40:18
-->
<template>
  <div class="tab-record-page page-container">
    <div class="banner-bl">
      <div class="banner-content">
        <span class="banner-title">一席记录</span>
      </div>
    </div>
    <div class="tabs-bl content">
      <div class="total_number">共{{ total }}个项目</div>
      <div class="sort-tabs">
        <div class="tab-item" :class="{ active: activeSortTab === 1 }" @click="onClickSort(1)">
          <span class="tab-content">按发布时间排序<i class="iconfont iconarrow" :class="{ isUp: sortTabStatus[1] }"></i></span>
        </div>
        <div class="tab-item" :class="{ active: activeSortTab === 2 }" @click="onClickSort(2)">
          <span slot="label" class="tab-content">按播放量排序<i class="iconfont iconarrow" :class="{ isUp: sortTabStatus[2] }"></i></span>
        </div>
        <div class="tab-bottom-active-line" :class="[activeSortTab === 1 ? 'left' : 'right']"></div>
      </div>
    </div>
    <div class="record-bl content">
      <div class="record-item" v-for="item in records" :key="item.id" @click="gotoDetail(item.id)">
        <div class="record_cover">
          <img class="record_cover-img" :src="item.cover" :alt="item.title" />
          <div class="record_time">{{ item.time }}</div>
        </div>
        <div class="record_info">
          <div class="record_top">
			  <div class="record_title">{{ item.title }}</div>
		  </div>
          <div class="record_date">{{ item.date }}</div>
          <div class="record_intro">{{ item.titlelanguage }}</div>
        </div>
      </div>
      <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
    </div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      // 排序tab
      activeSortTab: 1,
      sortTabStatus: {
        1: false,
        2: false,
      },
      pageNum: 1,
      pageSize: 5,
      total: 0,
      records: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!(from.path === '/record/detail' && vm.records.length)) {
        vm.refreshData();
        vm.initScrollTop();
      }
    });
  },
  computed: {
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  methods: {
    refreshData() {
      this.pageNum = 1;
      this.getData();
    },
    getData() {
      requestApi('/v3/api/site/record/extend/', {
        page: this.pageNum,
        page_size: this.pageSize,
        order_by: this.getSort(),
      }).then(({ items, total }) => {
        if (this.pageNum === 1) {
          this.records = items;
          this.total = total;
        } else {
          this.records = this.records.concat(items);
        }
      });
    },
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
    gotoDetail(id) {
      this.$router.push({
        path: '/record/detail',
        query: {
          id,
        },
      });
    },
    /**
     * @description: 0发布时间倒序 1发布时间正序 2播放量倒序 3播放量正序
     * @param {type}
     * @return {type}
     */
    getSort() {
      let res = 0;
      if (this.activeSortTab === 1) {
        res = this.sortTabStatus[this.activeSortTab] ? 1 : 0;
      } else if (this.activeSortTab === 2) {
        res = this.sortTabStatus[this.activeSortTab] ? 3 : 2;
      }
      return res;
    },
    onClickSort(val) {
      if (this.activeSortTab === val) {
        if (this.sortClickTimer) {
          return;
        }
        this.sortTabStatus[val] = !this.sortTabStatus[val];
        this.sortClickTimer = setTimeout(() => {
          this.sortClickTimer = null;
        }, 500);
      } else {
        this.activeSortTab = val;
      }
      this.refreshData();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-record-page {
  .banner-bl {
    height: 260px;
    width: 100%;
    background: url('../assets/imgs/speech-bg.jpg') no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    box-sizing: border-box;
    .banner-content {
      width: 80%;
      height: 100%;
      margin: 0 auto;
      max-width: 1140px;
      color: $C1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .banner-title {
        font-size: 47px;
        margin: 0;
        line-height: 1.5;
        letter-spacing: 3px;
        font-family: HYXinRenWenSongW;
      }
    }
  }
  .tabs-bl {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: auto;
    border-bottom: 1px solid #e7e7e7;
    margin-top: 40px;
    .total_number {
      font-family: HYXinRenWenSongW;
      font-size: 22px;
      color: $C6;
      cursor: pointer;
      line-height: 1;
      padding: 20px 0;
    }
    .sort-tabs {
      display: inline-flex;
      align-items: center;
      position: relative;
      width: 264px;
      height: 100%;
      .tab-item {
        flex: 1;
        font-size: 12px;
        cursor: pointer;
        color: $C9;
        padding: 0;
        position: relative;
        user-select: none;
        text-align: center;
        .iconfont {
          color: $C3;
          position: absolute;
          right: 0;
          display: inline-block;
          transition: transform 0.3s ease-out;
          &.isUp {
            transform: rotate(-180deg);
          }
        }
        &:hover,
        &.active {
          color: $C7;
        }
      }
      .tab-bottom-active-line {
        position: absolute;
        bottom: -22px;
        width: 32px;
        height: 2px;
        background-color: $C7;
        transform: translateX(-50%);
        transition: left 0.3s ease;
        &.left {
          left: 25%;
        }
        &.right {
          left: 75%;
        }
      }
    }
  }
  .record-bl {
    .record-item {
      width: 100%;
      height: 274px;
      background: $C1;
      display: flex;
      margin: 40px 0;
      cursor: pointer;
      position: relative;
      border: 1px solid $C11;
      .record_cover {
        width: 445px;
        position: relative;
        .record_time {
          color: $C1;
          font-size: 12px;
          background: $A1;
          width: 56px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          position: absolute;
          bottom: 10px;
          right: 10px;
          font-weight: 100;
        }
      }
      .record_info {
        flex: 1;
        position: relative;
        padding: 20px;
		.record_top {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
        .record_title {
          font-family: HYXinRenWenSongW;
          font-size: 27px;
          margin-top: 10px;
          margin-bottom: 8px;
        }
        .record_date {
          font-size: 14px;
          line-height: 14px;
          color: $C12;
          font-weight: 300;
          margin-bottom: 14px;
          letter-spacing: 1.7px;
        }
        .record_intro {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 0.5em;
          margin-top: 18px;
          font-weight: 300;
        }
      }
    }
  }
}
</style>
